import { Link, Outlet } from "react-router-dom";
import { Typography, Container, TextField, Switch, InputAdornment, InputLabel, FormControl, OutlinedInput, IconButton, Box, Toolbar, AppBar, Tabs, Tab } from "@mui/material";
import React, { useState } from "react";
import { IoIosArrowRoundBack } from "react-icons/io";
import user from '../../assets/images/user.svg'
import you from '../../assets/images/you.png'
import attachment from '../../assets/images/attachment.svg'
import send from '../../assets/images/send.svg'
import { FaCalendarAlt, FaParking, FaCreditCard, FaPencilAlt, FaTrash, FaPhoneAlt } from "react-icons/fa";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { BsHouseDoor, BsClockHistory, BsPerson, BsHeadset, BsChatDots } from "react-icons/bs";
import { Button, ButtonGroup, Card, Col, Form, Modal, Row } from "react-bootstrap";

const Chatsupport = () => {
  const [messages, setMessages] = useState([
    { sender: "Support", text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.", time: "10:29 AM", userType: "support" },
    { sender: "You", text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.", time: "10:29 AM", userType: "user" },
    { sender: "Support", text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.", time: "10:29 AM", userType: "support" },
    { sender: "You", text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.", time: "10:29 AM", userType: "user" },
  ]);

  const [inputMessage, setInputMessage] = useState("");

  const sendMessage = () => {
    if (inputMessage.trim() === "") return;

    const newMessage = {
      sender: "You",
      text: inputMessage,
      time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
      userType: "user",
    };

    setMessages([...messages, newMessage]);
    setInputMessage("");
  };

  const [phone, setPhone] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");


  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <Container>

        <div className="app-container">
          {/* Sticky Header */}
          <header className="header text-white text-center d-flex justify-content-between align-items-center">
            <Link to="/supportpage"><button className="back-button backbutton"><IoIosArrowRoundBack size={30} color="white" /></button></Link>
            <div>Support Chat</div>
            <div className=" visablityhidden"><button className="back-button">&nbsp;&nbsp;&nbsp;&nbsp;</button> </div>
          </header>
          <Container className="mt-3 px-3 pagewrap">
            <div className="" style={{ margin: "auto" }}>
              <div className="divider">
                <span>TODAY</span>
              </div>
              {/* <div className="card-header text-center text-muted">TODAY</div> */}
              <div className="card-body chatheight mt-3" style={{ maxHeight: "400px", overflowY: "auto", }}>
                {messages.map((msg, index) => (
                  <div key={index} className="mb-4">
                    {msg.userType === "support" ? (
                      <div className="d-flex align-items-start">
                        <div className="me-2">
                          <div className="rounded-circle  text-white d-flex align-items-center justify-content-center" style={{ width: "40px", height: "40px" }}>
                            <img src={user} width="35" height={35} alt="Logo" />
                          </div>
                        </div>
                        <div>
                          <strong>{msg.sender}</strong> <span className="text-muted" style={{ fontSize: "0.8em" }}>{msg.time}</span>
                          <div className="p-2 bg-light rounded mt-1">{msg.text}</div>
                        </div>
                      </div>
                    ) : (
                      <div className="d-flex align-items-start justify-content-end align-items-start">
                        <div className="text-end">
                          <span className="text-muted" style={{ fontSize: "0.8em" }}>{msg.time}</span> <strong>{msg.sender}</strong>
                          <div className="p-2 rounded mt-1 text-start yellowbox" style={{ backgroundColor: "#FAF8D6" }}>{msg.text}</div>
                        </div>
                        <div className="ms-2 d-flex ">
                          <img src={you} width="35" height={35} alt="Logo" className="rounded-circle" />

                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              {/* Chat Input */}
              <div className="card-footer supportchat d-flex align-items-center border-1">
                <input
                  type="text"
                  className=" border-0 inputwidth"
                  placeholder="Ask your question..."
                  value={inputMessage}
                  onChange={(e) => setInputMessage(e.target.value)}
                  onKeyPress={(e) => e.key === "Enter" && sendMessage()}
                />
                <label htmlFor="file-upload" className="custom-file-upload">
                  <img src={attachment} width="25" height={25} alt="Logo" />
                  <input id="file-upload" type="file" />
                </label>
                <button className="btn px-1" onClick={sendMessage} style={{ color: "#FFD700" }}>
                  <img src={send} width="25" height={25} alt="Logo" />
                </button>
              </div>
            </div>

          </Container>
        </div>
      </Container>


    </>
  );
};

export default Chatsupport;
